export const environment = {
  environmentDisplayName: 'Entwicklung',
  production: true,
  allowSkipSvSearch: true,
  allowOverrideErklaerungsjahre: true,
  apiUrl: 'https://beeexpert-staging.azurewebsites.net/api/v1',
  JWTAllowedDomains: ['beeexpert-staging.azurewebsites.net'].join(','),
  azureCommServiceEndpointUrl: 'https://beeexpertcommunicationservice.communication.azure.com',
  commPoc: true,
  spartaxProd: false,
  spartaxCompanyId: 21,
  spartaxCustomerPortalBaseUrl: 'https://testkundenportal.spartax.at',
  magirusCompanyId: 45,
};